import { render } from "./OverviewSport.vue?vue&type=template&id=58e2db09"
import script from "./OverviewSport.vue?vue&type=script&lang=js"
export * from "./OverviewSport.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__